import scrollLock from './functions/_scrollLock.js' // スクロールロック
if (document.getElementById('page-message')) {
  page()
}
function page() {
  //  #####    #####   ####  #####  ######
  //  ##  ##   ##     ##     ##       ##
  //  #####    #####   ###   #####    ##
  //  ##  ##   ##        ##  ##       ##
  //  ##   ##  #####  ####   #####    ##

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-mailReset')
    if (!item) {
      return
    }
    messageReset()
  })
  function messageReset() {
    // テキストを初期値に戻す
    const textList = document.getElementsByClassName('js-mailReset-text')
    for (const iterator of textList) {
      iterator.value = iterator.dataset.def
    }

    // ファイルを消す
    const fileList = document.getElementsByClassName('js-customFile-del')
    for (const iterator of fileList) {
      iterator.click()
    }

    // チェックを消す
    const checkList = document.getElementsByClassName('js-mailReset-check')
    for (const iterator of checkList) {
      iterator.checked = false
    }
  }

  //            ##   ##   ####  #####  #####
  //            ##   ##  ##     ##     ##  ##
  //  ########  ##   ##   ###   #####  #####
  //            ##   ##     ##  ##     ##  ##
  //             #####   ####   #####  ##   ##
  // ユーザーのみリセット
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-mailResetUser')
    if (!item) {
      return
    }

    // チェックを消す
    const checkList = document.getElementsByClassName('js-mailReset-check')
    for (const iterator of checkList) {
      iterator.checked = false
    }
  })

  //   ####  ##   ##  #####   ####  ##  ##             ####  ##    ##  ##     ##   ####
  //  ##     ##   ##  ##     ##     ## ##             ##      ##  ##   ####   ##  ##
  //  ##     #######  #####  ##     ####    ########   ###     ####    ##  ## ##  ##
  //  ##     ##   ##  ##     ##     ## ##                ##     ##     ##    ###  ##
  //   ####  ##   ##  #####   ####  ##  ##            ####      ##     ##     ##   ####
  /*
  data-check-syncが同じチェックボックスを同期する
  <input class="js-checkSync" type="checkbox" value="" name="" data-check-sync="check1">
  <input class="js-checkSync" type="checkbox" value="" name="" data-check-sync="check1">
  */
  if (document.getElementsByClassName('js-checkSync')[0]) {
    window.addEventListener('change', function (e) {
      if (!e.target.classList.contains('js-checkSync')) {
        return
      }
      const checkList = document.querySelectorAll('[data-check-sync="' + e.target.dataset.checkSync + '"]')
      for (const checkbox of checkList) {
        checkbox.checked = e.target.checked
      }
    })
  }

  //  ######  #####      ###     ####  #####
  //    ##    ##  ##    ## ##   ##     ##
  //    ##    #####    ##   ##  ##     #####
  //    ##    ##  ##   #######  ##     ##
  //    ##    ##   ##  ##   ##   ####  #####
  /*
  チェック内容を文字列やinputにトレース
  js-allCheckと連携可能
  <input type="checkbox" name="area[]" value="00000" class="js-checkTrace" data-trace-group="fuga" data-trace-name="テキストテキスト">
  <input type="checkbox" name="area[]" value="11111" class="js-checkTrace"  data-trace-group="fuga" data-trace-name="テキストテキスト">
    */
  if (document.getElementsByClassName('js-checkTrace')[0]) {
    window.addEventListener('change', function (e) {
      if (!e.target.classList.contains('js-checkTrace')) {
        return
      }
      const group = e.target.dataset.traceGroup // グループ取得
      checkTrace(group)
    })
  }
  function checkTrace(group) {
    // チェック内容を各所に反映する
    let nameData = []
    let valData = []

    const checkListChecked = document.querySelectorAll('.js-checkTrace[data-trace-group="' + group + '"]:checked')

    let skipTarget = ''
    for (let index = 0; index < checkListChecked.length; index++) {
      const element = checkListChecked[index]

      if (element.classList.contains('js-allCheck')) {
        skipTarget = element.dataset.allCheck // 全体チェックは以降スキップする
      }
      if (element.classList.contains('js-allCheck--' + skipTarget)) {
        continue
      }

      nameData.push(element.dataset.traceName) // 配列の末尾に追加
      valData.push(element.value) // 配列の末尾に追加
    }

    nameData = listFix(nameData)
    valData = listFix(valData)

    nameData = nameData.join(',') // 指定の区切り文字で文字列に変換
    valData = valData.join(',') // 指定の区切り文字で文字列に変換

    let toggle = true
    if (nameData === '') {
      nameData = '指定なし'
      toggle = false
    }

    const textTarget = document.getElementsByClassName('js-checkTrace-text--' + group)
    for (let index = 0; index < textTarget.length; index++) {
      textTarget[index].innerHTML = nameData
    }
    const hideTarget = document.getElementsByClassName('js-checkTrace-toggle--' + group)
    if (toggle) {
      for (let index = 0; index < hideTarget.length; index++) {
        hideTarget[index].classList.add('active')
      }
    } else {
      for (let index = 0; index < hideTarget.length; index++) {
        hideTarget[index].classList.remove('active')
      }
    }
    const valueTarget = document.getElementsByClassName('js-checkTrace-input--' + group)
    for (let index = 0; index < valueTarget.length; index++) {
      valueTarget[index].value = valData
    }

    // 配列を整理する
    function listFix(list) {
      list = new Set(list) // 配列の重複を除去
      list = Array.from(list) // Setでオブジェクト型に変わったため配列に戻す
      list = list.filter((v) => v) // 配列の空要素を除去
      return list
    }
  }

  //  ##   ##             ####  #####    ###    #####     ####  ##   ##
  //  ##   ##            ##     ##      ## ##   ##  ##   ##     ##   ##
  //  ##   ##  ########   ###   #####  ##   ##  #####    ##     #######
  //  ##   ##               ##  ##     #######  ##  ##   ##     ##   ##
  //   #####             ####   #####  ##   ##  ##   ##   ####  ##   ##
  // ユーザー検索
  const userItemList = document.getElementsByClassName('js-userSearch-item')

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-userSearch')
    if (!item) {
      return
    }
    userSearch()
  })

  window.addEventListener('keypress', function (e) {
    keyCheck(e)
  })
  window.addEventListener('input', function (e) {
    keyCheck(e)
  })
  function keyCheck(e) {
    const item = e.target.closest('.js-userSearch-name,.js-userSearch-id')
    if (!item) {
      return
    }
    // 未入力のEnterによる遷移を防止
    if (e.code && e.code === 'Enter') {
      e.preventDefault() // デフォルトのイベントを除去
      userSearch()
      return false
    }
  }

  function userSearch() {
    const inputName = document.querySelector('.js-userSearch-name').value
    const inputID = document.querySelector('.js-userSearch-id').value

    for (const userItem of userItemList) {
      // すべて非表示化
      userItem.classList.add('is-none')
    }

    if (inputName === '' && inputID === '') {
      // 未入力ならすべて解放
      for (const userItem of userItemList) {
        userItem.classList.remove('is-none')
      }
    }

    // 合致するものを解放
    for (const userItem of userItemList) {
      if (
        (~userItem.dataset.name.indexOf(inputName) || inputName === '') &&
        (~userItem.dataset.id.indexOf(inputID) || inputID === '')
      ) {
        // ID名前ともに文字列を含むか、検索指定されていない
        userItem.classList.remove('is-none')
      }
    }
  }

  //  ###    ###             ####  #####    ###    #####     ####  ##   ##
  //  ## #  # ##            ##     ##      ## ##   ##  ##   ##     ##   ##
  //  ##  ##  ##  ########   ###   #####  ##   ##  #####    ##     #######
  //  ##      ##               ##  ##     #######  ##  ##   ##     ##   ##
  //  ##      ##            ####   #####  ##   ##  ##   ##   ####  ##   ##
  userMailSearch()
  function userMailSearch() {
    const userItemList = document.getElementsByClassName('js-userSearchMail-item')

    window.addEventListener('click', function (e) {
      const item = e.target.closest('.js-userSearchMail')
      if (!item) {
        return
      }
      userSearch()
    })

    window.addEventListener('keypress', function (e) {
      keyCheck(e)
    })
    window.addEventListener('input', function (e) {
      keyCheck(e)
    })
    function keyCheck(e) {
      const item = e.target.closest('.js-userSearchMail-name,.js-userSearchMail-id')
      if (!item) {
        return
      }
      // 未入力のEnterによる遷移を防止
      if (e.code && e.code === 'Enter') {
        e.preventDefault() // デフォルトのイベントを除去
        userSearch()
        return false
      }
    }

    function userSearch() {
      const inputName = document.querySelector('.js-userSearchMail-name').value
      const inputID = document.querySelector('.js-userSearchMail-id').value

      for (const userItem of userItemList) {
        // すべて非表示化
        userItem.classList.add('is-none')
      }

      if (inputName === '' && inputID === '') {
        // 未入力ならすべて解放
        for (const userItem of userItemList) {
          userItem.classList.remove('is-none')
        }
      }

      // 合致するものを解放
      for (const userItem of userItemList) {
        if (
          (~userItem.dataset.name.indexOf(inputName) || inputName === '') &&
          (~userItem.dataset.id.indexOf(inputID) || inputID === '')
        ) {
          // ID名前ともに文字列を含むか、検索指定されていない
          userItem.classList.remove('is-none')
        }
      }
    }
  }

  //   ####  #####  ##     ##  ####
  //  ##     ##     ####   ##  ##  ##
  //   ###   #####  ##  ## ##  ##  ##
  //     ##  ##     ##    ###  ##  ##
  //  ####   #####  ##     ##  ####

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-sendMail')
    if (!item) {
      return
    }

    item.classList.add('is-false')
    item.innerText = '送信中...'

    return // Ajax廃止につき打ち切り

    try {
      const target = item.dataset.type

      /* global hUrl */

      const url = hUrl + 'api/'

      // POSTの中身を構築
      const param = new FormData()

      param.append('type', 'message')
      param.append('direction', document.querySelector('.js-sendMail-direction--' + target).value)
      param.append('id', document.querySelector('.js-sendMail-id--' + target).value)
      param.append('title', document.querySelector('.js-sendMail-title--' + target).value)
      param.append('text', document.querySelector('.js-sendMail-text--' + target).value)
      param.append('org_id', document.querySelector('.js-sendMail-org--' + target).value)

      const fileNameList = document.querySelectorAll('.js-sendMail-fileName--' + target + '-file')
      const fileList = document.querySelectorAll('.js-sendMail-file--' + target + '-file')
      const fileBase64List = document.querySelectorAll('.js-sendMail-fileBase64--' + target + '-file')
      if (fileNameList[0]) {
        for (let index = 0; index < fileNameList.length; index++) {
          const fileName = fileNameList[index].value
          if (fileName === '') {
            continue
          }

          const file = fileList[index]
          // console.log(file)

          // console.log(document.querySelector('.js-sendMail-file--' + target).files)
          // console.log(document.querySelector('.js-sendMail-file--' + target).files[0])
          // param.append('file', document.querySelector('.js-sendMail-file--' + target).value, fileName)

          param.append('file[]', file.files[0], fileName)
          param.append('file_name[]', fileName)

          // window.errorLog(fileName) // エラー出力
          // window.errorLog(file.files[0]) // エラー出力
          // window.errorLog(fileBase64List[index].value) // エラー出力
        }
      }

      applyAjax(url, param, item)
    } catch (error) {
      window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
      item.classList.remove('is-false')
      item.innerText = '送信する'

      window.errorLog(error) // エラー出力

      const fileNameList = document.querySelectorAll('.js-sendMail-fileName--' + target + '-file')
      const fileList = document.querySelectorAll('.js-sendMail-file--' + target + '-file')
      const fileBase64List = document.querySelectorAll('.js-sendMail-fileBase64--' + target + '-file')
      if (fileNameList[0]) {
        for (let index = 0; index < fileNameList.length; index++) {
          const fileName = fileNameList[index].value
          if (fileName === '') {
            continue
          }

          const file = fileList[index]
          // console.log(file)

          // console.log(document.querySelector('.js-sendMail-file--' + target).files)
          // console.log(document.querySelector('.js-sendMail-file--' + target).files[0])
          // param.append('file', document.querySelector('.js-sendMail-file--' + target).value, fileName)
          window.errorLog(fileName) // エラー出力
          // window.errorLog(file.files[0]) // エラー出力
          window.errorLog(fileBase64List[index].value) // エラー出力
        }
      }
    }
  })

  /*
             ###    ########  ########  ##       ##    ##
           ##   ##  ##     ## ##     ## ##         ####
  ####### ##     ## ########  ########  ##          ##
          ######### ##        ##        ##          ##
          ##     ## ##        ##        ########    ##
  */
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  let ajax = false
  function applyAjax(url, param, item) {
    try {
      if (ajax) {
        // 既に通信中なら切断
        ajax.abort()
      }

      ajax = new XMLHttpRequest() // Ajaxリクエスト
      ajax.open('post', url, true) // GET/POST, URL, 非同期処理

      ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

      // ajax.setRequestHeader('Content-Type', 'multipart/form-data')

      ajax.responseType = 'json' // 取得タイプ document text json
      ajax.timeout = 10000 // タイムアウト判定時間

      // console.log(param)
      ajax.send(param) // POSTリクエスト実行

      ajax.onload = function () {
        // アクセス成功
        if (ajax.status < 200 || ajax.status >= 400) {
          console.log('Error: Code ' + ajax.status) // エラー
          window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
          return
        }

        if (ajax.response['message']) {
          window.popToast(ajax.response['message'], 5000)
        }

        if (ajax.response['type'] === 'error') {
          // 確認画面をキャンセル
          document.querySelector('.js-modal--mail-send').classList.remove('active')
        }
        if (ajax.response['type'] === 'success') {
          // 完了画面に移動
          const modalList = document.getElementsByClassName('js-modal')
          for (const modal of modalList) {
            modal.classList.remove('active')
          }
          document.querySelector('.js-modal--mail-complete').classList.add('active')

          // 入力内容リセット
          messageReset()
        }
      }
      ajax.ontimeout = function (e) {
        // タイムアウト
        window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
        window.errorLog(e) // エラー出力
      }
      ajax.onerror = function (e) {
        // Ajax処理失敗
        window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
        window.errorLog(e) // エラー出力
      }
      ajax.onloadend = function () {
        // 受信成否に関わらず実行
        // intObsAjax()

        item.classList.remove('is-false')
        item.innerText = '送信する'

        ajax = false
      }
    } catch (error) {
      window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
      item.classList.remove('is-false')
      item.innerText = '送信する'
      window.errorLog(error) // エラー出力
    }
  }

  //   ####   ####  #####     #####   ##      ##
  //  ##     ##     ##  ##   ##   ##  ##      ##
  //   ###   ##     #####    ##   ##  ##      ##
  //     ##  ##     ##  ##   ##   ##  ##      ##
  //  ####    ####  ##   ##   #####   ######  ######
  const scrollFocus = document.querySelector('js-scrollFocus')
  if (scrollFocus) {
    scrollFocus.scrollIntoView(true)
  }

  //  #####   #####    ####  ##   ##   ####
  //  ##     ##   ##  ##     ##   ##  ##
  //  #####  ##   ##  ##     ##   ##   ###
  //  ##     ##   ##  ##     ##   ##     ##
  //  ##      #####    ####   #####   ####

  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-clickFocus')
    if (!item) {
      return
    }

    setTimeout(() => {
      const target = item.dataset.focusTarget
      const textarea = document.querySelector('.js-clickFocus--' + target)
      textarea.focus() // フォーカス
      textarea.setSelectionRange(0, 0) // キャレット座標
    }, 500)
  })

  /*
   ######  ##        #######  ##    ## ########
  ##       ##       ##     ## ####  ## ##
  ##       ##       ##     ## ## ## ## ######
  ##       ##       ##     ## ##  #### ##
   ######  ########  #######  ##    ## ########
  */
  /*
  js-clone-item--をjs-clone-frame--に複製する
  */
  if (document.getElementsByClassName('js-clone')[0]) {
    window.addEventListener('click', function (e) {
      if (!e.target.classList.contains('js-clone')) {
        return
      }

      const target = e.target.dataset.clone

      const item = document.getElementsByClassName('js-clone-item--' + target)[0]
      const frame = document.getElementsByClassName('js-clone-frame--' + target)[0]

      const clone = item.cloneNode(true)

      const items = document.querySelectorAll('.js-clone-item--send-file')

      if (items.length > 3) {
        document.querySelector('.response-error').innerText = '４つ以上追加できません'
        return
      } else {
        document.querySelector('.response-error').innerText = ''
      }

      // ファイルアップ欄調整
      clone.querySelector('input').value = '' // テキスト欄を空にする
      clone.querySelector('.js-clone-resetText').innerText = '選択されていません' // テキスト欄を空にする
      // activeを解除
      clone.innerHTML = clone.innerHTML.replace(/ active/g, '')

      // ファイル欄の識別子をユニーク化する
      const fileUpTag = e.target.dataset.cloneFileTag
      // 変数を使った正規表現
      const regCheck = fileUpTag
      const regChange = fileUpTag + '-' + randInt(0, 1000000000)
      const regexp = new RegExp(regCheck, 'g')
      clone.innerHTML = clone.innerHTML.replace(regexp, regChange)

      frame.appendChild(clone)
    })
  }
  //  #####      ###    ##     ##  ####
  //  ##  ##    ## ##   ####   ##  ##  ##
  //  #####    ##   ##  ##  ## ##  ##  ##
  //  ##  ##   #######  ##    ###  ##  ##
  //  ##   ##  ##   ##  ##     ##  ####
  // 指定範囲のランダムな整数を返す
  function randInt(min = 0, max = 100) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  //  ####    #####   ####  ######  #####     #####   ##    ##
  //  ##  ##  ##     ##       ##    ##  ##   ##   ##   ##  ##
  //  ##  ##  #####   ###     ##    #####    ##   ##    ####
  //  ##  ##  ##        ##    ##    ##  ##   ##   ##     ##
  //  ####    #####  ####     ##    ##   ##   #####      ##
  /*
  data属性に対応するクラスのDOMを削除する
  <button type="button" class="js-destroy" data-destroy="hoge">
      削除
  </button>
  <div class="js-destroy--hoge">これが消える</div>
  */

  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-destroy')) {
      return
    }
    const destroy = e.target.parentNode

    document.querySelector('.response-error').innerText = ''
    destroy.parentNode.removeChild(destroy)
  })

  //   ####    ###    ##   ##  #####
  //  ##      ## ##   ##   ##  ##
  //   ###   ##   ##  ##   ##  #####
  //     ##  #######   ## ##   ##
  //  ####   ##   ##    ###    #####
  // 下書き保存する
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-saveMail')
    if (!item) {
      return
    }

    item.classList.add('is-false')
    item.innerText = '保存中...'

    return // Ajax廃止につき打ち切り

    try {
      const target = item.dataset.type

      /* global hUrl */

      const url = hUrl + 'api/'

      // POSTの中身を構築
      const param = new FormData()

      param.append('type', 'message-save')
      param.append('direction', document.querySelector('.js-sendMail-direction--' + target).value)
      param.append('id', document.querySelector('.js-sendMail-id--' + target).value)
      param.append('title', document.querySelector('.js-sendMail-title--' + target).value)
      param.append('text', document.querySelector('.js-sendMail-text--' + target).value)
      param.append('org_id', document.querySelector('.js-sendMail-org--' + target).value)

      saveAjax(url, param, item)
    } catch (error) {
      window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
      item.classList.remove('is-false')
      item.innerText = '下書き保存して受信トレイに戻る'
      window.errorLog(error) // エラー出力
    }
  })

  /*
             ###    ########  ########  ##       ##    ##
           ##   ##  ##     ## ##     ## ##         ####
  ####### ##     ## ########  ########  ##          ##
          ######### ##        ##        ##          ##
          ##     ## ##        ##        ########    ##
  */
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function saveAjax(url, param, item) {
    try {
      if (ajax) {
        // 既に通信中なら切断
        ajax.abort()
      }

      ajax = new XMLHttpRequest() // Ajaxリクエスト
      ajax.open('post', url, true) // GET/POST, URL, 非同期処理

      ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

      // ajax.setRequestHeader('Content-Type', 'multipart/form-data')

      ajax.responseType = 'json' // 取得タイプ document text json
      ajax.timeout = 10000 // タイムアウト判定時間

      // console.log(param)
      ajax.send(param) // POSTリクエスト実行

      ajax.onload = function () {
        // アクセス成功
        if (ajax.status < 200 || ajax.status >= 400) {
          console.log('Error: Code ' + ajax.status) // エラー
          window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
          return
        }

        if (ajax.response['message']) {
          window.popToast(ajax.response['message'], 5000)
        }

        if (ajax.response['type'] === 'error') {
          // 確認画面をキャンセル
          // console.log('close')
          document.querySelector('.js-modal--mail-send').classList.remove('active')
        }
        if (ajax.response['type'] === 'success') {
          // モーダルを閉じる
          const modalList = document.getElementsByClassName('js-modal')
          for (const modal of modalList) {
            modal.classList.remove('active')
          }

          scrollLock('body', '.js-modal')

          // 入力内容リセット
          messageReset()

          window.ajaxUpdate('./?update_draft=1', '#draftArea', '#draftArea') // プルダウンをリロード
        }
      }
      ajax.ontimeout = function (e) {
        // タイムアウト
        window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
      }
      ajax.onerror = function (e) {
        // Ajax処理失敗
        window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
      }
      ajax.onloadend = function () {
        // 受信成否に関わらず実行
        // intObsAjax()

        item.classList.remove('is-false')
        item.innerText = '下書き保存して受信トレイに戻る'

        ajax = false
      }
    } catch (error) {
      window.popToast('エラーが発生しました。時間をおいて再度お試しください。')
      item.classList.remove('is-false')
      item.innerText = '下書き保存して受信トレイに戻る'
      window.errorLog(error) // エラー出力
    }
  }

  jQuery(function ($) {
    $('body').on('click', '.js-setUser', function (e) {
      const $target = $(this).data('modal')
      const seekerID = $(this).data('seeker')
      const jobID = $(this).data('job')
      $('.js-modal--' + $target)
        .find('input[name="entry_add"]')
        .removeClass('is-show')

      if (seekerID != '') {
        $('.mailSendUserList')
          .find('input[type="checkbox"][value="' + seekerID + '"]')
          .prop('checked', true)
        $('input[type="hidden"][name="id"]').val(seekerID)
      }
      $('input[type="hidden"][name="job_id"]').val(jobID)
    })

    $('.js-toggle').on('click', function (e) {
      e.preventDefault()
      const entryBox = $(this).closest('.mypageSeeker__btn--box')
      const entryName = $(entryBox).find('input')

      $(entryName).toggleClass('is-show')
      $(entryName).toggleClass('is-hide')
    })

    $('.js-sidebar-link').each(function () {
      if ($(this).hasClass('curr')) {
        $(this).closest('.md-acc').find('input[type="checkbox"]').prop('checked', true)
      }
    })
  })
}
